<template>
  <div class="localNav">
    <div class="u-containar">
      <ul class="localNav_list" :class="{ hidePc: !showPc }">
        <li v-for="(item, i) in list" :key="i">
          <a :href="`#${item.id}`" @click.prevent="scrollContents(item.id)">
            {{ item.label }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
import smoothscroll from 'smoothscroll-polyfill'

export default {
  name: 'LocalNav',

  props: {
    list: {
      type: Array,
      defaults: []
    },
    offset: {
      type: Number,
      default: 110
    },
    showPc: {
      type: Boolean,
      default: false
    }
  },

  setup(props: any) {
    smoothscroll.polyfill()

    const scrollContents = (anchor: string) => {
      const el = document.getElementById(anchor)
      if (!el) return
      window.scrollTo({
        top: el.offsetTop - props.offset,
        behavior: 'smooth'
      })
    }

    return {
      scrollContents
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.localNav {
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.08);
}

.localNav_list {
  display: flex;
  margin: 0 -10px;
  white-space: nowrap;
  @include mixins.mediaMax() {
    overflow-x: scroll;
  }

  > li > a {
    display: flex;
    padding: 0 10px;
    height: 60px;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &::after {
      content: '';
      display: block;
      width: 11px;
      height: 8px;
      background-image: url('~@/assets/icon/arrow-down.svg');
      background-size: 11px 8px;
    }
  }
}
.hidePc {
  @include mixins.media() {
    display: none;
  }
}
</style>
